import { Navigate, useLocation } from "react-router-dom";
import { Show } from "@clerk/react";
import { STATUS_STYLE, statusLabel } from "@/lib/brand";

export function RequireAuth({ children }) {
  const loc = useLocation();
  const back = encodeURIComponent(window.location.origin + loc.pathname + loc.search);
  return (
    <>
      <Show when="signed-in">{children}</Show>
      <Show when="signed-out"><Navigate to={`/sign-in?redirect_url=${back}`} replace /></Show>
    </>
  );
}

export function StatusBadge({ status, testId }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLE[status] || ""}`}>
      {statusLabel(status)}
    </span>
  );
}

export function PriceRows({ q }) {
  const rows = [
    [q.rate ? `Rental (${q.hours} hrs × ₹${q.rate}/hr)` : `Rental (${q.days || 1} day${q.days > 1 ? "s" : ""})`, q.rental],
    q.discount ? [`Long booking discount (−${q.discount_pct}%)`, -q.discount, "price-discount"] : null,
    q.surge_fee ? [`Peak & weekend pricing (+${q.surge_pct}% · ${q.peak_hours} hr${q.peak_hours > 1 ? "s" : ""})`, q.surge_fee] : null,
    q.protection_fee ? ["Trip protection", q.protection_fee] : null,
    q.driver_fee ? [`Driver charges (${q.driver_days} day${q.driver_days > 1 ? "s" : ""} × ₹${q.driver_rate.toLocaleString("en-IN")})`, q.driver_fee] : null,
    ["Convenience fee", q.convenience_fee],
    q.extension_taxable ? [`Trip extension (${q.extension_hours} hrs)`, q.extension_taxable, "price-extension"] : null,
    q.coupon_discount ? [`${q.coupon_label || "Coupon"} (${q.coupon_code})`, -q.coupon_discount, "price-coupon"] : null,
    ["GST (18%)", q.gst],
    ["Refundable security deposit", q.deposit],
  ].filter(Boolean);
  return (
    <div className="space-y-2 text-sm" data-testid="price-breakdown">
      {rows.map(([k, v, tid]) => (
        <div key={k} data-testid={tid} className={`flex justify-between ${v < 0 ? "text-emerald-700" : "text-neutral-600"}`}><span>{k}</span><span className={`font-medium ${v < 0 ? "text-emerald-700" : "text-neutral-900"}`}>{v < 0 ? "−" : ""}₹{Math.abs(v).toLocaleString("en-IN")}</span></div>
      ))}
      <div className="flex justify-between border-t border-black/10 pt-3 text-base font-semibold">
        <span>Total payable</span><span data-testid="price-total">₹{q.total.toLocaleString("en-IN")}</span>
      </div>
      <p className="text-xs text-neutral-500">{q.km_included} km included · Deposit refunded after return inspection</p>
    </div>
  );
}
